import { dealFormConfig } from '@/utils/preObjectManage/utils'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import { isNullOrUnDef } from '@/utils/is'
import { maxAomuntKeys, maxAmountUnitYuanKyes } from './enums'
import { getAllAppList } from '@/apis/objectManage'

interface ListItem {
  type: any
  title: string
  precisions?: number
}

export function formatFieldConfig(list: ListItem[], getPrecisionsByName: Fn) {
  const renderConfigArr: Recordable[] = []
  list.forEach(item => {
    const strategyFn = dealFormConfig[item.type] || dealFormConfig[fieldTypeConfig.singleLineText] // 默认值为单行文本
    const config = { ...item }
    if (isNullOrUnDef(config.precisions)) {
      // 根据不同的字段确确定精度
      config.precisions = getPrecisionsByName(item)
    }
    const renderConfig = strategyFn(
      { ...config },
      {
        tableColumnType: 10
      }
    )
    const customField = {
      ...config,
      renderConfig,
      columnInfo: { ...config }
      // columnUseScene: columnUseSceneEnums.addLayout
    }
    renderConfigArr.push({
      customField,
      value: '',
      ...config
    })
  })
  return renderConfigArr
}

// 金额不能超过1个亿
export function getAmountRules(item: Recordable) {
  if (maxAomuntKeys.includes(item.field) || maxAmountUnitYuanKyes.includes(item.field)) {
    const max = maxAmountUnitYuanKyes.includes(item.field) ? 10000 * 10000 : 10000
    const requiredRule = {
      validator: (_rule: any, value: string, callback: Fn) => {
        const val = Number(value)
        if (isNaN(val)) {
          callback()
        } else if (val > max) {
          callback(new Error('金额不能超过1个亿'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
    return [requiredRule]
  }
  return []
}

const columnKeys = [
  'applyAmount',
  'creditAmount',
  'loanAmount',
  'drawingAmount',
  'totalPrincipalAndInterest',
  'totalPrincipalRepayable',
  'totalRepayable',
  'totalUnpaid',
  'totalPenaltyInterestPayable',
  'totalPaid',
  'totalInterestPayable',
  'loanSum',
  'unpaidAmount',
  'unpaidInterest',
  'unpaidPrincipal',
  'repaymentTotal',
  'unpaidPenaltyInterest',
  'repaidAmount',
  'repayPenaltyInterest',
  'principal',
  'interest',
  'penaltyInterest',
  'repayPrincipal',
  'repayInterest',
  'earlyRepaymentMoney',
  'breakMoney',
  'expectLoanMoney',
  'notaryAmount',
  'paymentAmount',
  'intoAmount'
]

export const millageColumns = [...formatMillageColumns()]

function formatMillageColumns() {
  return columnKeys.map(key => {
    return {
      key,
      title: '',
      cellRender: { name: 'millage' }
    }
  })
}

// 合同用 —— 获取所有paas应用
export async function getPaasAppList() {
  try {
    const res: Recordable[] = await getAllAppList({ defineTypeList: [10, 20, 21] })
    let tableCode = 'e49c510abc8f4453863f0a7bce675f' // 签单管理code
    const data: Recordable[] =
      res
        ?.filter((el: Recordable) => !(el.appCode !== tableCode && el.defineType === 10))
        ?.map((el: Recordable) => {
          return {
            ...el,
            label: el.name,
            value: el.appCode,
            parent: '',
            level: '',
            disabled: el.enableStatus !== 0 // 不是启用状态的就禁止选择
          }
        }) || []
    return data
  } catch (e) {
    console.log(e)
    return []
  }
}
